import SecurityManager from 'modules/security/SecurityManager'

const PermissionView = ({ permission, permissions, excludedPermissions, and, children }) =>
  SecurityManager.hasPermission(permission || permissions) && (!and || SecurityManager.hasPermission(and)) && (!excludedPermissions || !SecurityManager.hasPermission(excludedPermissions)) ? children || null : null

export default PermissionView
